
export default {
  name: 'CentraProductList',
  props: {
    /**
     * Centra search props
     */
    searchResponse: {
      type: Object,
      required: true,
    },
    searchRequestId: {
      type: String,
      required: true,
    },
    centraCategory: {
      type: String,
      default: '',
    },
    centraProductIds: {
      type: String,
      default: '',
    },
    mobileColumns: {
      type: String,
      required: false,
      default: '2'
    },
    desktopColumns: {
      type: String,
      required: false,
      default: '5'
    },
    mobileProductWrapperMargin: {
      type: String,
      default: 'large'
    },
    desktopProductWrapperMargin: {
      type: String,
      default: 'none'
    },
    desktopIndent: {
      type: String,
      required: false,
      default: 'di--none'
    },
    description: {
      type: [Object, Array],
      required: false,
      default: () => ({}),
    }
  },
  data () {
    return {
      products: [],
    }
  },
  computed: {
    /**
     * Depending on the number of columns, we pass the 'mobileDisplayWidthOfViewportWidth' and 'desktopDisplayWidthOfViewportWidth'
     * props into the child component where we can apply them on images to get optimized image sizes
     */
    mobileDisplayWidthOfViewportWidth () {
      return 100 / parseInt(this.mobileColumns)
    },
    desktopDisplayWidthOfViewportWidth () {
      return 100 / parseInt(this.desktopColumns)
    },
  },
  mounted () {
    this.initializeProducts()
  },
  methods: {
    initializeProducts () {
      if (this.searchResponse?.mappedProducts) {
        if (this.centraProductIds?.length) {
          this.products = this.sortProducts()
          return
        }
        this.products = this.searchResponse.mappedProducts
      }
    },
    // Since centra does not return products in the same order we requested the (when pinning ids),
    // need to sort towards the original array of product ids from Storyblok.
    sortProducts () {
      const sortOrder = this.centraProductIds?.split(',')
      const tempList = Array.from(this.searchResponse.mappedProducts)
      return tempList.sort((a, b) => {
        return sortOrder.indexOf(a.objectID) - sortOrder.indexOf(b.objectID)
      })
    }
  },
}
